<microsec-loading-overlay [isLoading]="!!isLoading">
  @if (!!report) {
    <microsec-card [isNestedCard]="true">
      <div class="grid grid-cols-12 gap-4">
        <label class="col-span-12 font-bold"> Report Details </label>
        <div class="col-span-12">
          <div class="list-fields mx-4">
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Name</label>
              <label class="col-span-8">{{ report.name }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!report.description">
              <label class="col-span-4">Description</label>
              <label class="col-span-8">{{ report.description }}</label>
            </div>
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4">Type</label>
              <label class="col-span-8">{{ report.reportTypeName }}</label>
            </div>
          </div>
        </div>
        @if (!!report.completeReportFilters?.length) {
          <div class="col-span-12 px-4">
            @for (filter of report.completeReportFilters; track $index) {
              <div class="grid grid-cols-12 gap-4">
                @if (!!isArray(filter.value)) {
                  @switch (filter.key) {
                    @case ('device_ids') {
                      <div class="col-span-12">
                        <microsec-card [isNestedCard]="true" [isTableCard]="true">
                          <microsec-common-table
                            itemName="Selected Device"
                            [values]="filter.value"
                            [cols]="[
                              {
                                field: 'device_label',
                                header: 'Name'
                              }
                            ]" />
                        </microsec-card>
                      </div>
                    }
                    @default {
                      <label class="col-span-12 font-bold">{{ filter.label }}</label>
                      <div class="col-span-12 flex flex-wrap gap-2">
                        @for (item of filter.value; track $index) {
                          @switch (filter.key) {
                            @case ('zone_ids') {
                              <div class="custom-chip" [style]="{ background: util.hexToRgba(zones[item]?.color), color: zones[item]?.color }">
                                {{ zones[item]?.label || 'Zone ID: ' + item }}
                              </div>
                            }
                            @case ('connection_ids') {
                              <div>
                                {{ connections[item]?.name || 'Connection ID: ' + item }}
                              </div>
                            }
                            @case ('device_ids') {
                              <div>
                                {{ devices[item]?.label || 'Device ID: ' + item }}
                              </div>
                            }
                            @case ('assessment_ids') {
                              <div>
                                {{ assessments[item]?.name || 'Assessment ID: ' + item }}
                              </div>
                            }
                            @default {
                              <div>
                                {{ item }}
                              </div>
                            }
                          }
                        }
                      </div>
                    }
                  }
                }
                @if (!isArray(filter.value)) {
                  <label class="col-span-4 font-bold">{{ filter.label }}</label>
                  <label class="col-span-8">{{ filter.value }}</label>
                }
              </div>
            }
          </div>
        }
      </div>
    </microsec-card>
  }
</microsec-loading-overlay>
